 <template>
    <gj-modal size="1200x650" v-bind="$attrs" v-on="$listeners" :visible.sync="modalVisible">
        <template #header>符合规则的订单</template>
        <template #content>
            <gj-table
                ref="gjTable"
                :data="dataList"
                :columns="columns"
                :height="570"
                :adapt-height="false">
            </gj-table>
        </template>
    </gj-modal>
</template>

<script>
import { saleOrderType, saleOrderStatus } from '@/utils/options'
import { modalMixIn } from "@/minxins";
import { mapGetters } from 'vuex';
export default {
    name: "send-rule-preview",
    mixins: [modalMixIn],
    props: {
        dataList: Array
    },
    computed: {
      ...mapGetters({
        marketOption: 'marketOption',
      }),
    },
    data() {
        return {
            columns: [
                { id: 'orderId', header: '订单编号', field: 'orderId', minWidth: '130px' },
                { id: 'orderType', header: '订单类型', field: 'orderType', minWidth: '80px', overflowLine: 1, },
                { id: 'marketId', header: '店铺/站点', field: 'option:marketId', minWidth: '120px', options: () => this.marketOption, },
                { id: 'status', header: '状态', field: 'option:status', minWidth: '80px', options: () => saleOrderStatus },
                { id: 'purchaseDate', header: '订购时间(站点时间)', field: 'purchaseDate', minWidth: '140px' },
                { id: 'deliveryDate', header: '发货时间(站点时间)', field: 'deliveryDate', minWidth: '140px' },
                { id: 'expectedDeliveryTime', header: '到货时间(站点时间)', field: 'expectedDeliveryTime', minWidth: '140px' },
            ],
        }
    },
    created() {

    },
}
</script>

